export enum ZustandStorageKeys {
  AssetModal = 'zustand/assetModal',
  AssetModalPlayer = 'zustand/assetModal/player',
  ContextSourcesFieldTable = 'zustand/contextSourcesFieldTable',
  CreativePerformance = 'zustand/creativePerformance',
  CreativePerformanceAdsTableColumns = 'zustand/creativePerformance/adsTableColumns',
  CreditUsageDismissedAlerts = 'zustand/dismissedAlerts/creditUsage',
  CreditUsageDismissedAlertsSession = 'zustand/dismissedAlerts/creditUsage/session',
  DevTools = 'zustand/devTools',
  OnboardingPreferences = 'zustand/onboardingPreferences',
  PendingEmailCooldown = 'zustand/pendingEmail/cooldown',
  SkillOnboardingPendingRun = 'zustand/skillOnboarding/pendingRun',
  WorkspaceRightPanel = 'zustand/workspaceRightPanel',
  WorkspaceSidebar = 'zustand/workspaceSidebar',
  WorkspaceSidebarLibraries = 'zustand/workspaceSidebar/libraries',
  WorkspaceSidebarSectionFavoriteBoards = 'zustand/workspaceSidebar/section/favoriteBoards',
  WorkspaceSidebarSectionLibraries = 'zustand/workspaceSidebar/section/libraries',
  WorkspaceSidebarSectionRecentCanvases = 'zustand/workspaceSidebar/section/recentCanvases',
  WorkspaceSidebarSectionWorkspaceBoards = 'zustand/workspaceSidebar/section/workspaceBoards',
  WorkspaceSidebarWorkspaceBoards = 'zustand/workspaceSidebar/workspaceBoards',
}
